import * as GenModels  from "./GenericModels";

export interface ServiceMaster {

    id: string;
    name: GenModels.Name;   
    address: GenModels.Address;
    phone: GenModels.PhoneNumbers;
    notes: string;   
}

export const initialState: ServiceMaster = {
    id: '',
    name: { ...GenModels.initialStateName },
    address: { ...GenModels.initialStateAddress },
    phone: { ...GenModels.initialStatePhoneNumber },
    notes: ''
}